import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'KpiStatusCountChips',
  props: {
    completed: null,
    skipped: null,
    incomplete: null,
    fullWidth: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var doneCount = computed(function () {
      return props.completed + props.skipped;
    });
    var totalCount = computed(function () {
      return doneCount.value + props.incomplete;
    });
    var completionPercent = computed(function () {
      if (totalCount.value <= 0) return 0;
      return doneCount.value / totalCount.value * 100;
    });
    return {
      __sfc: true,
      props: props,
      doneCount: doneCount,
      totalCount: totalCount,
      completionPercent: completionPercent
    };
  }
});